import { Typography } from "@material-ui/core";
import React, { ReactNode } from "react";
import "./CardField.sass";
import {toKebabCase} from 'Shared/utilities/stringFormatHelpers';

type CardFieldProps = {
  name: string;
  value: ReactNode;
  className?: string;
};

const CardField = (props: CardFieldProps) => (
  <Typography
    component="div"
    className={`card-field__row ${props.className || ""}`}
  >
    <div id={`card-field-label-${toKebabCase(props.name)}`} className={`card-field__label ${props.className || ""}`}>
      {props.name}:
    </div>
    <div id={`card-field-value-${toKebabCase(props.name)}`} className={`card-field__value ${props.className || ""}`}>
      {props.value ? props.value : "N/A"}
    </div>
  </Typography>
);

export default CardField;
